// extracted by mini-css-extract-plugin
export default {"participantAvatar":"ParticipantsList-module__participantAvatar--poMuO","participantLimitNotice":"ParticipantsList-module__participantLimitNotice--uz4xv"};